import { useContext, useState } from "react";
import { SettingsContext } from "../App";
import Label from "./Label";
import api from "./api/api";
import currencyFormat, { getStatusLabel } from "./functions/functions";
import Moment from "react-moment";
import "../css/LocalHistory.css";
import OrderSheet from "./user/OrderSheet";

export default function LocalHistory() {
	const { history, setLocalHistoryVisible } = useContext(SettingsContext);
	const [order, setOrder] = useState(false);

	return (
		<>
			<div className="local-history">
				<div className="local-history-content">
					<div className="local-history-header">
						<div>
							<Label number={76} />
						</div>
						<button
							className="local-history-header-close-button"
							onClick={() => setLocalHistoryVisible(false)}
						>
							&times;
						</button>
					</div>
					<div className="local-history-scroll">
						{history.length == 0 ? (
							<div className="text-center">Nessun ordine trovato</div>
						) : (
							history.map((order, i) => (
								<div key={i}>
									<div className="local-history-line">
										<div>
											<div className="bold">Ordine N°{order.id}</div>
											<div className="small">
												<Moment format={"DD/MM/YYYY LT"} locale="it">
													{order.delivery_date}
												</Moment>
											</div>
										</div>
										<div className="small">
											<button
												className="basic-button"
												onClick={() => setOrder(order)}
											>
												<Label number={97} />
											</button>
										</div>
									</div>
									<hr />
								</div>
							))
						)}
					</div>
				</div>
			</div>
			{order && (
				<div className="local-history">
					<div className="local-history-content">
						<div className="local-history-scroll">
							<OrderSheet order={order} setOrder={setOrder} />
						</div>
					</div>
				</div>
			)}
		</>
	);
}
